import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref } from 'vue'
  import type { ComponentSize, FormInstance, FormRules } from 'element-plus'
  interface RuleForm {
    name: string
    phone: string
    email: string
    company: string
    desc: string
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ContactDialog',
  props: {
    dialogVisible: { type: Boolean }
  },
  emits: ['submitForm'],
  setup(__props: any, { emit: emits }) {

const props = __props;

  
  const formSize = ref<ComponentSize>('default')
  const ruleFormRef = ref<FormInstance>()
  const ruleForm = reactive<RuleForm>({
    name: '',
    phone: '',
    email: '',
    company: '',
    desc: ''
  })

  const checkDesc = (_rule, value, callback) => {
    const text = String(value ?? '').trim()
    if (!text) {
      callback(new Error('请输入留言内容'))
    } else if (text.length < 5) {
      callback(new Error('留言内容至少 5 个字'))
    } else {
      callback()
    }
  }

  const rules = reactive<FormRules<RuleForm>>({
    name: [
      { required: true, message: '请输入姓名', trigger: 'blur' },
      { whitespace: true, message: '请输入姓名', trigger: 'blur' },
      { min: 1, max: 30, message: '姓名长度应在 1 到 30 个字', trigger: 'blur' },
    ],
    phone: [
      { required: true, message: '请输入联系方式', trigger: 'blur' },
      { whitespace: true, message: '请输入联系方式', trigger: 'blur' },
    ],
    desc: [
      { required: true, message: '请输入留言内容', trigger: 'blur' },
      { validator: checkDesc, trigger: 'blur' },
    ],
  })

  const submitForm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
      if (valid) {
        emits('submitForm', {
          name: ruleForm.name.trim(),
          phone: ruleForm.phone.trim(),
          email: ruleForm.email.trim(),
          company: ruleForm.company.trim(),
          desc: ruleForm.desc.trim(),
        })
      } else {
        console.log('error submit!', fields)
      }
    })
  }
  
  const resetForm = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    formEl.resetFields()
  }

  
return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    style: {"max-width":"600px"},
    model: ruleForm,
    rules: rules,
    "label-width": "auto",
    class: "demo-ruleForm",
    size: formSize.value,
    "status-icon": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "姓名",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "电话",
        prop: "phone"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.phone) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "邮箱",
        prop: "email"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.email) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "单位",
        prop: "company"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.company,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.company) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "留言",
        prop: "desc",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: ruleForm.desc,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.desc) = $event)),
            type: "textarea",
            autosize: { minRows: 5, maxRows: 15 },
            placeholder: "请输入留言内容",
            maxlength: "1024",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "submitBtn",
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm(ruleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交留言 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (resetForm(ruleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "size"]))
}
}

})